// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import Card from "@mui/material/Card";

// Material Dashboard 2 React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Billing page components
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import API_ENDPOINTS from "config/api";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import MDBadge from "components/MDBadge";
import { Icon, IconButton, Menu, MenuItem } from "@mui/material";
import MDButton from "components/MDButton";
import { useMaterialUIController } from "context"; // Importa el controlador de contexto de Material UI
import Modal from "@mui/material/Modal";

function Billing() {
  const [usuarios, setUsuarios] = useState({ columns: [], rows: [] });
  const [loading, setLoading] = useState(true);
  const [empresas, setEmpresas] = useState([]);
  const [error, setError] = useState(null);
  const [menuAnchor, setMenuAnchor] = useState(null); // State to hold the anchor element for the menu
  const [selectedUsuarioId, setSelectedUsuarioId] = useState(null);
  const [controller] = useMaterialUIController(); // Obtén el controlador del contexto
  const { sidenavColor } = controller; // Obtén el color del sidenav desde el controlador
  const [open, setOpen] = useState(false);
  const [roles, setRoles] = useState([]); // Define el estado para roles

  const handleOpen = () => setOpenRegistrar(true); // Para el modal de registrar
  const handleClose = () => setOpenRegistrar(false);

  const [openRegistrar, setOpenRegistrar] = useState(false);
  const [openEditar, setOpenEditar] = useState(false);

  const handleOpenMenu = (event, id) => {
    setMenuAnchor(event.currentTarget); // Store the anchor element
    setSelectedUsuarioId(id);
  };

  const handleCloseMenu = () => {
    setMenuAnchor(null);
    setSelectedUsuarioId(null);
  };
  const closeEditar = () => setOpenEditar(false);

  const originalRows = useRef([]);

  const handleSearch = (searchTerm) => {
    if (searchTerm === "") {
      setUsuarios((prevUsuarios) => ({ ...prevUsuarios, rows: originalRows.current }));
    } else {
      const filteredRows = originalRows.current.filter((row) => {
        const values = Object.values(row);
        return values.some((value) => {
          if (typeof value === "string") {
            return value.toLowerCase().includes(searchTerm.toLowerCase());
          }
          return false;
        });
      });

      setUsuarios((prevUsuarios) => ({ ...prevUsuarios, rows: filteredRows }));
    }
  };

  async function getRol(usuario) {
    try {
      const response = await axios.get(API_ENDPOINTS.USUARIO_FIND_ROL, { params: usuario });
      return response.data.nombre || "Desconocido";
    } catch (error) {
      console.error("Error fetching role:", error);
      return "Desconocido";
    }
  }

  useEffect(() => {
    const fetchUsuarios = async () => {
      try {
        const response = await axios.get(API_ENDPOINTS.USUARIOS);
        const empresas = await axios.get(API_ENDPOINTS.EMPRESAS);
        const empresaData = empresas.data;
        const usuariosData = response.data;

        // Transform the data into the format expected by DataTable
        const rows = await Promise.all(
          usuariosData.map(async (usuario, index) => ({
            indice: (index + 1).toString(),
            nom: usuario.nombre,
            nombre: (
              <MDBox display="flex" alignItems="center" lineHeight={1}>
                <MDTypography
                  display="block"
                  variant="button"
                  fontWeight="medium"
                  ml={1}
                  lineHeight={1}
                >
                  {usuario.nombre}
                </MDTypography>
              </MDBox>
            ),
            email: usuario.email,
            telefono: usuario.telefono,
            estado: (
              <MDBox ml={-1}>
                <MDBadge
                  badgeContent={usuario.estado ? "activo" : "inactivo"}
                  color={usuario.estado ? "success" : "dark"}
                  variant="gradient"
                  size="sm"
                />
              </MDBox>
            ),
            acción: (
              <IconButton onClick={(event) => handleOpenMenu(event, usuario.email)}>
                <Icon>more_vert</Icon>
              </IconButton>
            ),
            empresa:
              Array.isArray(usuario.empresa_id) && usuario.empresa_id.length > 1
                ? usuario.empresa_id
                    .map((element) => empresaData.find((empresa) => empresa.id === element).nombre)
                    .join(", ")
                : empresaData.find((empresa) => empresa.id === usuario.empresa_id)?.nombre ||
                  "Desconocido",
            rol: await getRol(usuario),
          }))
        );

        const columns = [
          { Header: "#", accessor: "indice", width: "5%" },
          { Header: "Nombre", accessor: "nombre", width: "20%" },
          { Header: "Teléfono", accessor: "telefono", width: "20%" },
          { Header: "Empresa", accessor: "empresa", width: "15%" },
          { Header: "Email", accessor: "email", width: "25%" },
          { Header: "Estatus", accessor: "estado", width: "5%" },
          { Header: "Rol", accessor: "rol", width: "5%" },
          { Header: "Acción", accessor: "acción", width: "5%" },
        ];

        setUsuarios({ columns: columns, rows: rows });
        originalRows.current = rows; // Save the loaded rows to originalRows
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    };

    const fetchEmpresas = async () => {
      try {
        const response = await axios.get(API_ENDPOINTS.EMPRESAS);
        setEmpresas(response.data);
      } catch (err) {
        setError(err);
      }
    };

    fetchUsuarios();
    fetchEmpresas();
  }, []);

  const registrarBD = (e) => {
    try {
      e.preventDefault();
      const form = document.getElementById("registerForm");
      const formData = new FormData(form);
      const empresas = axios.get(API_ENDPOINTS.EMPRESAS);
      const empresaData = empresas.data;
      const rol = {
        user_id: 0,
        nombre: "",
        empresa_id: 0,
      };
      const user = {
        empresa_id: 0,
        nombre: "",
        telefono: "",
        email: "",
        estado: "",
      };

      formData.forEach((value, key) => {
        // ...
      });
      const userResponse = axios.post(API_ENDPOINTS.USUARIOS, user);
      console.log(userResponse.data.id);
      rol.user_id = userResponse.data.id;
      axios.post(API_ENDPOINTS.ROLES, rol);
      alert("Usuario registrado exitosamente");
      handleClose();
    } catch (err) {
      console.log(err);
      alert("Error al registrar el usuario");
    }
  };

  const registrar = (
    <Modal open={openRegistrar} onClose={handleClose}>
      <form
        id="registerForm"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          padding: "20px",
          backgroundColor: "rgb(240, 240, 240)",
          borderRadius: "8px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 1000,
          width: "40rem",
        }}
        onSubmit={registrarBD}
      >
        <MDBox
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 16px",
            marginTop: "-24px",
            padding: "24px 16px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          }}
          bgColor={sidenavColor}
        >
          <MDTypography variant="h6" color="white" fontWeight="medium">
            <em>Registrar Usuario</em>
          </MDTypography>
        </MDBox>
        <MDBox
          style={{ display: "flex", flexDirection: "row", marginBottom: "10px", gap: "10px" }}
          my={2}
          justifyContent="center"
        >
          <input
            type="text"
            name="nombre"
            placeholder="Nombre"
            required
            style={{
              flex: 1,
              padding: "10px",
              fontSize: "14px",
              borderRadius: "4px",
              border: "1px #ccc",
              fontStyle: "italic",
              borderStyle: "none",
            }}
          />
          <input
            type="text"
            name="telefono"
            placeholder="Teléfono"
            required
            style={{
              flex: 1,
              padding: "10px",
              fontSize: "14px",
              borderRadius: "4px",
              border: "1px #ccc",
              fontStyle: "italic",
              borderStyle: "none",
            }}
          />
        </MDBox>
        <MDBox style={{ display: "flex", flexDirection: "column", marginBottom: "10px" }}>
          <label style={{ fontWeight: "bold", marginBottom: "5px" }}>Empresa:</label>
          <select
            name="empresa"
            required
            onChange={(e) => {
              const selectedEmpresa = empresas.find((empresa) => empresa.nombre === e.target.value);
              let rolesData = [];

              if (selectedEmpresa?.roles) {
                // Convierte el JSON a un arreglo
                rolesData = Array.isArray(selectedEmpresa.roles)
                  ? selectedEmpresa.roles
                  : Object.values(selectedEmpresa.roles); // Usa Object.values para extraer los valores
              }

              setRoles(rolesData); // Asegura que roles sea un arreglo
              console.log(rolesData);
            }}
            style={{
              padding: "10px",
              fontSize: "14px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              fontStyle: "italic",
              borderStyle: "none",
            }}
          >
            <option value="" disabled selected>
              Seleccione una empresa
            </option>
            {empresas.map((empresa) => (
              <option key={empresa.id} value={empresa.nombre}>
                {empresa.nombre}
              </option>
            ))}
          </select>
        </MDBox>
        <MDBox style={{ display: "flex", flexDirection: "column", marginBottom: "10px" }}>
          <label style={{ fontWeight: "bold", marginBottom: "5px" }}>Rol:</label>
          <select
            name="rol"
            required
            style={{
              padding: "10px",
              fontSize: "14px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              fontStyle: "italic",
              borderStyle: "none",
            }}
          >
            <option value="" disabled selected>
              Seleccione un rol
            </option>
            {(Array.isArray(roles) ? roles : []).map((rol, index) => (
              <option key={index} value={rol}>
                {rol}
              </option>
            ))}
          </select>
        </MDBox>
        <MDBox
          style={{ display: "flex", flexDirection: "row", marginBottom: "10px" }}
          justifyContent="center"
        >
          <label style={{ fontWeight: "bold", marginBottom: "5px", marginRight: "0.5rem" }}>
            Estatus:
          </label>
          <select
            name="estado"
            required
            style={{
              padding: "10px",
              fontSize: "14px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              borderStyle: "none",
            }}
          >
            <option value="activo">
              <em>Activo</em>
            </option>
            <option value="inactivo">
              <em>Inactivo</em>
            </option>
          </select>
        </MDBox>
        <MDBox style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
          <MDButton
            type="button"
            id="cancelButton"
            style={{
              padding: "10px",
              borderRadius: "4px",
              border: "none",
              backgroundColor: "#6c757d",
              color: "#fff",
              cursor: "pointer",
            }}
            onClick={handleClose}
          >
            Cancelar
          </MDButton>
          <MDButton
            type="submit"
            color={sidenavColor}
            style={{
              padding: "10px",
              borderRadius: "4px",
              border: "none",
              cursor: "pointer",
            }}
          >
            Registrar
          </MDButton>
        </MDBox>
      </form>
    </Modal>
  );

  const editarBD = async (e) => {
    try {
      e.preventDefault();
      const form = document.getElementById("editerForm");
      const formData = new FormData(form);
      const empresaData = await axios.get(API_ENDPOINTS.EMPRESAS).then((res) => res.data);
      const usuarioAnterior = {
        nombre: usuarios.rows.find((usuario) => usuario.email === selectedUsuarioId).nom,
        email: selectedUsuarioId,
        telefono: usuarios.rows.find((usuario) => usuario.email === selectedUsuarioId).telefono,
      };
      console.log(usuarioAnterior);
      const rol = await axios.get(API_ENDPOINTS.USUARIO_FIND_ROL, { params: usuarioAnterior });
      const roldata = rol.data;
      console.log(roldata);
      const user = {
        empresa_id: 0,
        nombre: "",
        telefono: "",
        email: "",
        estado: "",
      };

      formData.forEach((value, key) => {
        if (key === "nombre") user.nombre = value;
        if (key === "telefono") user.telefono = value;
        if (key === "email") user.email = value;
        if (key === "estado") user.estado = value;
        if (key === "empresa")
          user.empresa_id = empresaData.find((empresa) => empresa.nombre === value)?.id;
        if (key === "rol") roldata.nombre = value;
        roldata.empresa_id = user.empresa_id;
      });

      // Update user
      await axios.put(API_ENDPOINTS.USUARIO(roldata.user_id), user);
      //Update rol
      await axios.put(API_ENDPOINTS.ROL(roldata.id), roldata);

      alert("Usuario editado exitosamente");
      handleClose();

      // Refresh the user list
      fetchUsuarios();
    } catch (err) {
      console.error(err);
      alert("Error al editar el usuario");
    }
  };

  const editar = (
    <Modal open={openEditar} onClose={closeEditar}>
      <form
        id="editerForm"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          padding: "20px",
          backgroundColor: "rgb(240, 240, 240)",
          borderRadius: "8px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 1000,
          width: "40rem",
        }}
        onSubmit={editarBD}
      >
        <MDBox
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 16px",
            marginTop: "-24px",
            padding: "24px 16px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          }}
          bgColor={sidenavColor}
        >
          <MDTypography variant="h6" color="white" fontWeight="medium">
            <em>Editar Usuario</em>
          </MDTypography>
        </MDBox>
        <MDBox
          style={{ display: "flex", flexDirection: "row", marginBottom: "10px", gap: "10px" }}
          my={2}
          justifyContent="center"
        >
          <input
            type="text"
            name="nombre"
            defaultValue={
              selectedUsuarioId &&
              usuarios.rows.find((usuario) => usuario.email === selectedUsuarioId).nom
            }
            required
            style={{
              flex: 1,
              padding: "10px",
              fontSize: "14px",
              borderRadius: "4px",
              border: "1px #ccc",
              fontStyle: "italic",
              borderStyle: "none",
            }}
          />
          <input
            type="text"
            name="telefono"
            defaultValue={
              selectedUsuarioId &&
              usuarios.rows.find((usuario) => usuario.email === selectedUsuarioId).telefono
            }
            required
            style={{
              flex: 1,
              padding: "10px",
              fontSize: "14px",
              borderRadius: "4px",
              border: "1px #ccc",
              fontStyle: "italic",
              borderStyle: "none",
            }}
          />
        </MDBox>
        <MDBox style={{ display: "flex", flexDirection: "column", marginBottom: "10px" }}>
          <label style={{ fontWeight: "bold", marginBottom: "5px" }}>Empresa:</label>
          <select
            name="empresa"
            defaultValue={
              selectedUsuarioId &&
              usuarios.rows.find((usuario) => usuario.email === selectedUsuarioId).empresa
            }
            required
            style={{
              padding: "10px",
              fontSize: "14px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              fontStyle: "italic",
              borderStyle: "none",
            }}
          >
            {empresas.map((empresa) => (
              <option key={empresa.id} value={empresa.nombre}>
                {empresa.nombre}
              </option>
            ))}
          </select>
        </MDBox>
        <MDBox style={{ display: "flex", flexDirection: "column", marginBottom: "10px" }}>
          <input
            type="email"
            name="email"
            defaultValue={
              selectedUsuarioId &&
              usuarios.rows.find((usuario) => usuario.email === selectedUsuarioId).email
            }
            required
            style={{
              padding: "10px",
              fontSize: "14px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              fontStyle: "italic",
              borderStyle: "none",
            }}
          />
        </MDBox>
        <MDBox
          style={{ display: "flex", flexDirection: "row", marginBottom: "10px" }}
          justifyContent="center"
        >
          <label style={{ fontWeight: "bold", marginBottom: "5px", marginRight: "0.5rem" }}>
            Rol:
          </label>
          <input
            type="text"
            name="rol"
            defaultValue={
              selectedUsuarioId &&
              usuarios.rows.find((usuario) => usuario.email === selectedUsuarioId).rol
            }
            required
            style={{
              padding: "10px",
              fontSize: "14px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              fontStyle: "italic",
              borderStyle: "none",
              marginRight: "2rem",
            }}
          />
          <label style={{ fontWeight: "bold", marginBottom: "5px", marginRight: "0.5rem" }}>
            Estatus:
          </label>
          <select
            name="estado"
            defaultValue={
              selectedUsuarioId &&
              usuarios.rows.find((usuario) => usuario.email === selectedUsuarioId).estado
            }
            required
            style={{
              padding: "10px",
              fontSize: "14px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              borderStyle: "none",
            }}
          >
            <option value="activo">
              <em>Activo</em>
            </option>
            <option value="inactivo">
              <em>Inactivo</em>
            </option>
          </select>
        </MDBox>
        <MDBox style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
          <MDButton
            type="button"
            id="cancelButton"
            style={{
              padding: "10px",
              borderRadius: "4px",
              border: "none",
              backgroundColor: "#6c757d",
              color: "#fff",
              cursor: "pointer",
            }}
            onClick={closeEditar}
          >
            Cancelar
          </MDButton>
          <MDButton
            type="submit"
            color={sidenavColor}
            style={{
              padding: "10px",
              borderRadius: "4px",
              border: "none",
              color: "#fff",
              cursor: "pointer",
            }}
          >
            Editar
          </MDButton>
        </MDBox>
      </form>
    </Modal>
  );

  const handleEdit = (id) => {
    console.log(id);
    setSelectedUsuarioId(id);
    setOpenEditar(true); // Para el modal de editar
  };

  const renderMenu = () => (
    <Menu
      anchorEl={menuAnchor}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(menuAnchor)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}
    >
      <MenuItem onClick={() => handleEdit(selectedUsuarioId)}>
        <MDTypography variant="body2" color="dark">
          Editar
        </MDTypography>
      </MenuItem>
      <MenuItem onClick={handleCloseMenu}>
        <MDTypography variant="body2" color="dark">
          Eliminar
        </MDTypography>
      </MenuItem>
    </Menu>
  );

  if (loading) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor={sidenavColor}
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography variant="h6" color="white">
                    Lista de Usuarios
                  </MDTypography>
                </MDBox>
                <MDBox pt={3}>
                  <MDTypography variant="body2" color="text" fontWeight="medium">
                    Cargando lista de usuarios...
                  </MDTypography>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        <Footer />
      </DashboardLayout>
    );
  }

  if (error) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor={sidenavColor}
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography variant="h6" color="white">
                    Lista de Usuarios
                  </MDTypography>
                </MDBox>
                <MDBox pt={3}>
                  <MDTypography variant="body2" color="error" fontWeight="medium">
                    Error al cargar la lista de usuarios: {error.message}
                  </MDTypography>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        <Footer />
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Lista de Usuarios
                </MDTypography>
              </MDBox>
              <MDBox padding={3}>
                <MDBox display="flex">
                  <MDButton variant="gradient" color={sidenavColor} onClick={handleOpen}>
                    Registrar Usuario
                  </MDButton>
                  <MDBox component="form" display="flex" justifyContent="flex-end" flexGrow={1}>
                    <input
                      type="text"
                      placeholder="Buscar"
                      onChange={(e) => handleSearch(e.target.value)}
                      style={{
                        padding: "8px",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                        marginRight: "8px",
                      }}
                    />
                  </MDBox>
                </MDBox>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={usuarios}
                  isSorted={false}
                  entriesPerPage={true}
                  showTotalEntries={true}
                  noEndBorder
                />
                {renderMenu()}
                {registrar}
                {editar}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Billing;
